import axios from 'axios';
import {useQuery} from '@tanstack/react-query';

export interface BudgetContact {name: string; email: string; phone: string; notes: string}
export interface ContactSession {
  csrf_token: string;
  template: {id: string; name: string; thumbnail: string} | null;
  contact: BudgetContact | null;
  channels: {whatsapp_ready: boolean; email_ready: boolean};
}
export const websiteCenterClient = axios.create({baseURL: '/', withCredentials: true, headers: {Accept: 'application/json'}});
export function useWebsiteContactSession(template = '') {
  return useQuery({queryKey: ['website-contact-session', template], queryFn: () => websiteCenterClient.get<ContactSession>('website-center/session', {params: {template}}).then(response => response.data), staleTime: 0, gcTime: 0, retry: false});
}
export function websiteContactUrl(params: URLSearchParams) {
  const target = new URLSearchParams({service: 'budget-website', template: params.get('template') || ''});
  for (const key of ['package', 'online_store']) if (params.has(key)) target.set(key, params.get(key)!);
  return `/contact?${target}`;
}
export const quotationServices: Record<string, string> = {'custom-website': 'Website Khas', 'system-development': 'Pembangunan Sistem', 'premium-corporate': 'Website Korporat Premium', 'government-website': 'Website Kerajaan'};
export const quotationStatuses: Record<string, string> = {new: 'Baharu', contacted: 'Dihubungi', in_discussion: 'Dalam Perbincangan', quoted: 'Sebut Harga Diberikan', won: 'Berjaya', lost: 'Tidak Berjaya'};